import { parseISO } from 'date-fns';
import { useLocale } from '../stores/userPreferencesStore';

export function useFormatDate() {
  const locale = useLocale();

  /**
   * Formats a bare date-only string (no time component — e.g. a Salesforce `Date` field, always
   * `yyyy-MM-dd`) using the active locale's numeric date order. Parses via `parseISO`, which
   * treats a date-only string as local midnight rather than a UTC instant — a calendar date has
   * no time-of-day component to convert through a timezone.
   */
  const formatDateOnly = (dateOnly: string): string =>
    new Intl.DateTimeFormat(locale, { year: 'numeric', month: '2-digit', day: '2-digit' }).format(parseISO(dateOnly));

  return { formatDateOnly };
}
